import React from "react";
import SectionContainer from "../common/SectionContainer";
import SectionTitle from "../common/SectionTitle";

const outcomes = [
  {
    title: "Generate Qualified Demand",
    description:
      "Build acquisition systems that attract customers with genuine buying intent."
  },
  {
    title: "Improve Marketing Efficiency",
    description:
      "Reduce wasted spend through better targeting, measurement and optimization."
  },
  {
    title: "Scale Digital Infrastructure",
    description:
      "Create websites, automation and analytics systems that support growth."
  },
  {
    title: "Create Sustainable Growth",
    description:
      "Move beyond campaigns and build repeatable growth processes."
  }
];

function OutcomeSection() {
  return (
    <SectionContainer background="#ffffff">

      <SectionTitle
        title="Growth Focused. Outcome Driven."
        subtitle="Every engagement is designed around measurable business outcomes rather than vanity metrics."
      />

      <div className="outcomes-grid">
        {outcomes.map((item) => (
          <div
            key={item.title}
            className="outcome-card"
          >
            <h3>{item.title}</h3>

            <p>{item.description}</p>
          </div>
        ))}
      </div>

    </SectionContainer>
  );
}

export default OutcomeSection;